import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import { PictureAsPdf, Image } from '@material-ui/icons';
import { PDF_HEX_COLOR, IMG_HEX_COLOR } from 'src/constants/fileIconColor';

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 4
  }
}));

function FileThumbnail({ fileSrc, fileType }) {
  const classes = useStyles();
  const [imgSrc, setImgSrc] = useState(fileSrc);
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    setIsImageLoading(true);
    setImgSrc(fileSrc);
  }, [fileSrc]);

  const ImagePlaceHolder = () => {
    if (fileType === 'pdf') {
      return <PictureAsPdf htmlColor={PDF_HEX_COLOR} />
    }

    return <Image htmlColor={IMG_HEX_COLOR} />
  }

  return (
    <React.Fragment>
      {isImageLoading && ImagePlaceHolder()}
      <img
        style={isImageLoading ? { display: 'none' } : {}}
        onLoad={() => setIsImageLoading(false)}
        className={classes.root}
        src={imgSrc}
        width="105%"
        height="95%"
      />
    </React.Fragment>
  );
}

FileThumbnail.propTypes = {
  fileSrc: PropTypes.string.isRequired,
  fileType: PropTypes.string.isRequired
};

export default FileThumbnail
